import { createVanIconComponent } from "./van"

const Bill = createVanIconComponent("bill")
export default Bill
